import React from "react";

function TokenFormat(value){
    let salida = parseFloat(value);
    return salida.toFixed(4);
}
export default TokenFormat